import { useState, useEffect, useCallback } from 'react';
import {
  fetchGlobalPropertyDetailsCustomOptions,
  getPropertyCustomOptionUsageMap
} from '../services/propertyDetailsCustomService';

export function usePropertyDetailsCustomCatalog(enabled = true, { includeUsage = true } = {}) {
  const [catalog, setCatalog] = useState([]);
  const [usageMap, setUsageMap] = useState({});
  const [loading, setLoading] = useState(Boolean(enabled));

  const reload = useCallback(async () => {
    if (!enabled) {
      setCatalog([]);
      setUsageMap({});
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const options = await fetchGlobalPropertyDetailsCustomOptions();
      setCatalog(options);
      setLoading(false);

      if (includeUsage) {
        try {
          const usage = await getPropertyCustomOptionUsageMap();
          setUsageMap(usage);
        } catch (usageError) {
          console.error('Erro ao carregar uso das opções do imóvel:', usageError);
          setUsageMap({});
        }
      } else {
        setUsageMap({});
      }
    } catch (error) {
      console.error('Erro ao carregar opções personalizadas do imóvel:', error);
      setCatalog([]);
      setUsageMap({});
      setLoading(false);
    }
  }, [enabled, includeUsage]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { catalog, usageMap, loading, reload, setCatalog, setUsageMap };
}
